/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { API, graphqlOperation } from "aws-amplify";
import { getAccount } from "../../../graphql/account/account-queries";

import { isEmpty } from "lodash";
import DateFnsUtils from "@date-io/date-fns";

import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  Hidden,
  InputAdornment,
  makeStyles,
  TextField as MuiTextField,
  Typography,
  useMediaQuery,
} from "@material-ui/core";
import { MuiPickersUtilsProvider, DateTimePicker } from "@material-ui/pickers";
import { orange } from "@material-ui/core/colors";

import {
  ArrayField,
  ArrayInput,
  Button,
  CheckboxGroupInput,
  Datagrid,
  Edit,
  FileInput,
  FormDataConsumer,
  FormTab,
  FunctionField,
  IconButtonWithTooltip,
  ListContextProvider,
  Loading,
  minValue,
  number,
  NumberField,
  NumberInput,
  RadioButtonGroupInput,
  required,
  SelectInput,
  SimpleFormIterator,
  TabbedForm,
  TextField,
  TextInput,
  Toolbar,
  useEditController,
  useList,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import {
  AddIcon,
  ArrivedAtIcon,
  AttachFileIcon,
  CalendarIcon,
  CollectedAtIcon,
  CreatedAtIcon,
  ExceptionIcon,
  PlacedAtIcon,
  ReleasedAtIcon,
  SealIcon,
  TimerIcon,
  TimerOffIcon,
} from "../../../components/common/iconography";
import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { AddressInput } from "../../../components/common/AddressInput";
import { CarrierNameInput } from "../../../components/common/CarrierNameInput";
import { CopyToClipboardButton } from "../../../components/common/CopyToClipboardButton";
// import { ChecklistDialog } from "../../../components/common/ChecklistDialog";
import {
  CustomField,
  CustomFields,
} from "../../../components/common/CustomFields";
import { FileField } from "../../../components/common/FileField";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HistoryTab } from "../../../components/common/HistoryTab";
import { NotesTab } from "../../../components/common/NotesTab";
import CustomizableDatagrid from "../../../components/common/ra-customizable-datagrid";

import {
  fetchSavedAddresses,
  isInternalAccount,
  useOperatingAccount,
} from "../accounts/AccountUtils";
import {
  fetchOutboundBillingRules,
  filterApplicableManualRules,
  getManualRuleChoices,
} from "../accounts/chargeRules/ChargeRuleUtils";
import { ChargeEvent } from "../accounts/chargeRules/chargeRuleConstants";
import { isAuthorized, logError } from "../../../utils/appUtils";
import {
  ACCEPTED_FILES,
  AclType,
  CarrierType,
  CarrierTypes,
  FilePaths,
  GateCheckInStatus,
  MAX_FILES,
  MAX_PHOTO_NUM_OUTBOUND,
  OutboundState,
  OutboundStatus,
  ResourceType,
  ShipmentLineItemStatus,
  TransferOptions,
  TrueOrFalse,
  UnitWeightOptions,
  Workflow,
} from "../../../utils/constants";
import { handleFileChange } from "../../../utils/fileUtils";
import {
  fetchCarrierEquipmentTypes,
  getRailEquipmentTypes,
  getTruckEquipmentTypes,
  getUnitName,
  isBulkCommodity,
  unitOptionRenderer,
} from "../../../utils/loadTypeUtils";
import {
  resolveScheduledDateTime,
  getDateTimeFromUtc,
  getHoursMinutesDuration,
  getYardCalendarDaysInclusive,
} from "../../../utils/dateUtils";
import {
  // deepRedirect,
  getBackPath,
  piecesRenderer,
  totalToPickPiecesRenderer,
  trimDecimal,
} from "../../../utils/utils";
import { BetaBadge, NewBadge } from "../../../components/common/FeatureBadges";
import {
  EventsCalendar,
  EventsCalendarDialog,
} from "../../../components/common/EventsCalendar";
import PhotoInput from "../../../components/common/PhotoInput";
import { SmartTipIcon } from "../../../components/common/SmartTipIcon";
import { Scheduler } from "../../../components/common/scheduler/Scheduler";
import { SignatureBlock } from "../../../components/common/SignatureBlock";

import { GateCheckInControl } from "../gateCheckIns/GateCheckInControl";
import {
  canOfferManualGateCheckIn,
  isStagingManualGateCheckIn,
  wantsManualGateCheckIn,
} from "../gateCheckIns/gateCheckInUtils";
import { createStagedGateEdit } from "../gateCheckIns/stagedGateEdit";
import { useActiveGateCheckIn } from "../gateCheckIns/useActiveGateCheckIn";
import { useGateQueueTurn } from "../gateCheckIns/useGateQueueTurn";
import {
  canSetGateStatus,
  outOfTurnTooltip,
} from "../../../utils/gateQueueOrder";
import { sessionYardRunsDriverCheckIn } from "../../../utils/gateAccess";
import { gatePlacementRefusal } from "../../../utils/shipmentPlacement";
import { isLinked } from "../../../utils/shipWith";
import { DialogSaveButton } from "./DialogSaveButton";
import { AdviceApproveRejectButton } from "./AdviceApproveRejectButton";
import { DeepDeleteButton } from "./DeepDeleteButton";
import { OutboundAside } from "./OutboundAside";
import { InventorySearchDialog } from "./InventorySearchDialog";
import { SealNumbersDialog } from "./SealNumberDialog";
import { OutboundEditActions } from "./OutboundEditActions";
import {
  applyManualRuleDefaultQuantity,
  calcNetWeight,
  calcTotalQuantity,
  getAllInventories,
  getAutoCharges,
  getInfoBubble,
  getManualChargeAmount,
  getSaveAddressControl,
  handleContainerPickupChange,
  handleMustTarpChange,
  handlePickListWeight,
  InventoryItemsEditGridInput,
  ShipmentItemEditActionButtons,
  updateLambdaOutboundMini,
  duplicateReferenceFieldHelperText,
  isOutboundDuplicateReferenceField,
  outboundDuplicateLabelsToFieldSources,
  validateOutboundUnicity,
  validateRefernceNumberUnicity,
} from "./OutboundUtils";
import { AddressBookSelect } from "./AddressBookSelect";
import { AccountTypeIcon } from "../../../components/common/AccountTypeIcon";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  icons: {
    position: "relative",
    top: theme.spacing(0.4),
    marginRight: theme.spacing(1),
    color: orange[500],
  },
}));

const validateRequired = required();
const validateEmptyMinNum = (value) =>
  number()(value) || minValue(0, "Must be 0 or greater")(value);
const validateTareWeight = (value) =>
  required()(value) ||
  number()(value) ||
  minValue(0, "Must be 0 or greater")(value);
const isTareWeightRequired = (formData) => formData.ladenWeight;

const LadenWeightValidator = (value, allValues) => {
  if (
    allValues.tareWeight &&
    allValues.departureDateTime &&
    value !== 0 &&
    !value
  ) {
    // return an object just like the other validators
    return { message: `Required`, isRequired: true };
  }

  if (allValues?.tareWeight && value) {
    if (value < allValues.tareWeight) {
      return { message: `Laden weight must be greater than tare weight.` };
    }
  }
  return undefined;
};
const validateLadenWeight = [
  number(),
  minValue(0, "Must be greater than 0"),
  LadenWeightValidator,
];
const isLadenWeightRequired = (formData) =>
  formData.tareWeight && formData.departureDateTime;

const validateRailCarNumber = (value, allValues) => {
  if (
    (allValues?.carrierType === CarrierType.RAIL ||
      // either the driver arrived at the gate or the yard placed the load
      allValues?.arrivalDateTime ||
      allValues?.placementDateTime ||
      // Subsumed by the arrival above, which the predicate now reads too —
      // stated anyway, so the gate's own rule survives whatever the arrival
      // clause becomes. On a truck this field is the trailer number the
      // check-in row is built from.
      isStagingManualGateCheckIn(allValues, true)) &&
    !value
  ) {
    // return an object just like the other validators
    return { message: `Required`, isRequired: true };
  }
  return undefined;
};
const isRailcarNumberRequired = (formData) =>
  validateRailCarNumber(null, formData) ? true : false;

/**
 * The stage the save is about to land on, read off the stamps the form holds
 * right now. Status is only recomputed when the save runs
 * (DialogSaveButton.setNextState), so a load the office rolls back — arrival
 * and placement cleared — still carries PLACED in the form values. Asking the
 * status kept the fields required for a load that is PENDING again, so ask the
 * stamps the status is derived from instead. Loaded and released are stated
 * through their own stamps for the same reason.
 */
const isDispatched = (allValues) =>
  Boolean(
    allValues?.arrivalDateTime ||
    allValues?.placementDateTime ||
    allValues?.endDateTime ||
    allValues?.departureDateTime,
  );

const validateCarrierName = (value, allValues) => {
  // A rail load names no carrier here: the mark on the car is the railroad's,
  // not a Carrier the yard booked, and the car number is what identifies it.
  if (allValues?.carrierType === CarrierType.RAIL) return undefined;
  // A truck the office is checking in at the gate names its carrier too — the
  // check-in row the save mints carries it to a crew who see no shipment.
  if (
    (isDispatched(allValues) || isStagingManualGateCheckIn(allValues, true)) &&
    !value
  ) {
    // return an object just like the other validators
    return { message: `Required`, isRequired: true };
  }
  return undefined;
};
const isCarrierNameRequired = (formData) =>
  validateCarrierName(null, formData) ? true : false;

// Validate Pick List Row and return Validation Errors that will prevent form submission
const validatePickListRow = (data) => {
  const errors = {};
  let helperText = false;

  if (data && data.status === ShipmentLineItemStatus.NEW) {
    if (
      (typeof data.totalQuantityToPick === `undefined` ||
        Number(data.totalQuantityToPick) <= 0) &&
      !data?.inventory?.containerNumber
    ) {
      errors.totalQuantityToPick = true;
      helperText = "Qty. To Pick must be greater than 0";
    }
    if (data.quantityAvailable < 0) {
      errors.totalQuantityToPick = true;
      helperText = "Qty. To Pick exceetds Available.";
    }
    errors.helperText = helperText;
  }
  return errors;
};

const fetchSetupData = async (
  setLoading,
  setRailEquipmentChoices,
  setTruckEquipmentChoices,
  notify,
) => {
  try {
    setLoading(true);
    const carrierEquipmentPromise = fetchCarrierEquipmentTypes();
    const carrierEquipmentResp = await carrierEquipmentPromise;

    setRailEquipmentChoices(carrierEquipmentResp.railEquipmentTypes);
    setTruckEquipmentChoices(carrierEquipmentResp.truckEquipmentTypes);
  } catch (err) {
    logError("outboundShipment:OutboundEdit:getAccountData", err, notify);
  } finally {
    setLoading(false);
  }
};

const ShipmentSetupTab = ({
  record,
  operatingAccount,
  setOperatingAccount,
  bolFile,
  bolNumber,
  photos,
  setPhotos,
  setIsContainerPickUp,
  setShipmentLineItems,
  backPath,
  history,
  notify,
  ...props
}) => {
  const form = useForm();
  const [loading, setLoading] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const CarrierTypesReversed = [].concat(CarrierTypes).reverse();
  const [addressBook, setAddressBook] = useState([]);
  const [railEquipmentChoices, setRailEquipmentChoices] = useState(
    getRailEquipmentTypes(),
  );
  const [truckEquipmentChoices, setTruckEquipmentChoices] = useState(
    getTruckEquipmentTypes(),
  );
  const [carrierEquipmentChoices, setCarrierEquipmentChoices] = useState(
    record?.carrierType === CarrierType.RAIL
      ? railEquipmentChoices
      : record?.carrierType === CarrierType.TRUCK
        ? truckEquipmentChoices
        : [],
  );
  const [duplicateReferenceFields, setDuplicateReferenceFields] = useState([]);
  // const [isChecklistDialogOpen, setIsChecklistDialogOpen] = useState(false);

  form.registerField(
    "bolNumber",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "transferToAccountName",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "checklist",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "shipTo",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );

  useEffect(() => {
    fetchSetupData(
      setLoading,
      setRailEquipmentChoices,
      setTruckEquipmentChoices,
      notify,
    );
    if (record?.accountId) {
      fetchSavedAddresses(
        record?.billToAccountId || record?.accountId,
        notify,
        null,
        setAddressBook,
      );
    }
  }, [record]);

  useEffect(() => {
    if (record?.carrierType) {
      if (record.carrierType === CarrierType.RAIL) {
        setCarrierEquipmentChoices(railEquipmentChoices);
      } else if (record.carrierType === CarrierType.TRUCK) {
        setCarrierEquipmentChoices(truckEquipmentChoices);
      } else {
        setCarrierEquipmentChoices([]);
      }
    }
  }, [record?.carrierType, railEquipmentChoices, truckEquipmentChoices]);

  useEffect(() => {
    if (bolFile?.key) form.change("bolFile", bolFile);
  }, [bolFile]);

  useEffect(() => {
    if (bolNumber) form.change("bolNumber", bolNumber);
  }, [bolNumber]);

  useEffect(() => {
    const validateInitialReferenceFields = async () => {
      if (!record?.accountId) {
        setDuplicateReferenceFields([]);
        return;
      }
      const duplicateLabels = await validateOutboundUnicity(record);
      setDuplicateReferenceFields(
        outboundDuplicateLabelsToFieldSources(duplicateLabels),
      );
    };

    validateInitialReferenceFields();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record.id]);

  const getTransferOptions = () => {
    if (record.status === OutboundStatus.RELEASED) return TransferOptions;
    else return [TransferOptions[1]];
  };

  const handleTransferChange = (value, formData) => {
    debugger;
    if (isEmpty(value)) {
      // internalAccount can only do internal Transfer (no need for edit)
      if (formData.carrierName === "TRANSFER") form.change("carrierName", null);
      if (formData.pickupNumber === "TRANSFER")
        form.change("pickupNumber", null);
      if (formData.railCarNumber === "TRANSFER")
        form.change("railCarNumber", null);
    } else {
      form.change("skipSignature", true);
      form.change("billToAccountId", "");
      form.change("transferToAccountId", "");
    }
  };

  // UN USED ---------------------
  // const getChecklist = (formData) => {
  //   if (record.account?.outboundChecklist) {
  //     return (
  //       <Box component="span">
  //         <Button
  //           onClick={() => setIsChecklistDialogOpen(true)}
  //           label="Checklist"
  //         />
  //         <ChecklistDialog
  //           model={formData}
  //           definition={record.account?.outboundChecklist}
  //           isOpen={isChecklistDialogOpen}
  //           setOpen={setIsChecklistDialogOpen}
  //           saveModel={() => {
  //             form.change("checklist", [...formData.checklist]);
  //             setTimeout(
  //               () => form.change("checklist", [...formData.checklist]),
  //               50
  //             );
  //           }}
  //           title="Outbound Checklist"
  //         ></ChecklistDialog>
  //       </Box>
  //     );
  //   }

  //   return (
  //     <Button
  //       onClick={() =>
  //         deepRedirect(
  //           history,
  //           `/accounts/${record.accountId}/dispatch`,
  //           history.location.pathname,
  //           backPath,
  //           { tab: 1 }
  //         )
  //       }
  //       label="Create Checklist"
  //     />
  //   );
  // };

  const getAccountHelperText = () => {
    if (operatingAccount?.overLimit) {
      return "⚠️ Account over credit limit.";
    } else if (operatingAccount?.overDue) {
      return "⚠️ Account over due.";
    }
    return false;
  };

  const handleReferenceNumberBlur =
    (fieldSource, normalizedFieldSource) => async () => {
      const isDuplicate = await validateRefernceNumberUnicity(
        form.getState().values,
        normalizedFieldSource,
        notify,
      );
      setDuplicateReferenceFields((prev) => {
        const next = new Set(prev);
        if (isDuplicate) next.add(fieldSource);
        else next.delete(fieldSource);
        return [...next];
      });
    };

  const handleOperatingAccountChange = async (selectedAccount) => {
    if (!selectedAccount?.id) return;
    try {
      setLoading(true);
      // if source accont is pass-through, fetch operatingAccount for billing and settings
      const resp = await API.graphql(
        graphqlOperation(getAccount, { id: selectedAccount.id }),
      );
      const acct = resp.data?.getAccount;
      if (!acct) return;

      // Edit flow intentionally preserves existing transfer selections.
      // Create flow clears transfer/transferTo when operating account changes.
      form.change("account", acct);
      form.change("accountName", acct.businessName);
      form.change("billToAccountId", acct.id);
      form.change("instructions", acct.outboundInstructions || "");
      form.change("mustTarp", acct.mustTarp || false);
      form.change("skipSignature", acct.outboundSkipSignature || false);
      setOperatingAccount(acct);

      // must be either transferTo or billTo
      form.change("transfer", undefined);
      form.change("transferToAccountId", "");

      fetchSavedAddresses(acct.id, notify, null, setAddressBook);
    } catch (error) {
      logError(
        "outboundShipment:OutboundEdit:handleOperatingAccountChange",
        error,
        notify,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAddressBookEntryUpdated = (updated) => {
    setAddressBook((prev) =>
      prev.map((a) => (a.id === updated.id ? updated : a)),
    );
  };

  const getCustomFieldsSection = (formData) => {
    const accountFields = (operatingAccount || record.account)
      ?.outboundCustomFields;
    if (!record.customFields?.length && !accountFields?.length) return null;
    return (
      <CustomFields
        {...props}
        recordFields={record.customFields}
        accountFields={accountFields}
        disabled={formData.status === OutboundStatus.RELEASED}
        width={4}
      />
    );
  };

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Grid container direction="column" spacing={1}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <TextInput
                source="accountName"
                label="Account"
                variant="outlined"
                disabled
                fullWidth
                helperText={getAccountHelperText()}
                options={{
                  error:
                    operatingAccount?.overLimit || operatingAccount?.overDue,
                }}
                InputProps={{
                  endAdornment: <AccountTypeIcon account={record?.account} />,
                }}
              />
            </Grid>
            {isInternalAccount(record?.account) &&
              isEmpty(formData.transfer) && (
                <Grid item xs={12} sm={6} md={4}>
                  <AccountDropDown
                    source="billToAccountId"
                    label="Operating Account"
                    excludeAccountIds={
                      record?.accountId ? [record?.accountId] : []
                    }
                    validate={validateRequired}
                    allowEmpty={false}
                    disabled={
                      record.status === OutboundStatus.ARRIVED ||
                      record.status === OutboundStatus.PLACED ||
                      record.status === OutboundStatus.LOADED ||
                      record.status === OutboundStatus.RELEASED
                    }
                    onAccountChange={handleOperatingAccountChange}
                    variant="outlined"
                    fullWidth
                    helperText={false}
                  />
                </Grid>
              )}
            {!isInternalAccount(record?.account) &&
              record.status !== OutboundStatus.ADVICE_PENDING && (
                <Grid item xs={12} sm={6} md={4}>
                  <CheckboxGroupInput
                    source="transfer"
                    label="Inventory Transfer"
                    fullWidth
                    disabled={record.status === OutboundStatus.RELEASED}
                    style={{ marginTop: 0 }}
                    choices={getTransferOptions()}
                    helperText={false}
                    onChange={(value) => handleTransferChange(value, formData)}
                    format={(v) => (typeof v === "string" ? [v] : v)}
                    parse={(v) => (typeof v === "string" ? [v] : v)}
                  />
                </Grid>
              )}
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <TextInput
                source="poNumber"
                label="PO Number"
                variant="outlined"
                fullWidth
                parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                disabled={Boolean(record?.invoiceId?.trim())}
                validate={validateRequired}
                onBlur={handleReferenceNumberBlur(
                  "poNumber",
                  "normalizedPoNumber",
                )}
                error={isOutboundDuplicateReferenceField(
                  duplicateReferenceFields,
                  "poNumber",
                )}
                helperText={duplicateReferenceFieldHelperText(
                  duplicateReferenceFields,
                  "poNumber",
                )}
                FormHelperTextProps={{
                  component: "div",
                  style: isOutboundDuplicateReferenceField(
                    duplicateReferenceFields,
                    "poNumber",
                  )
                    ? { color: "#f44336" }
                    : undefined,
                }}
                inputProps={{ style: { textTransform: "uppercase" } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CopyToClipboardButton
                        text={formData.poNumber || ""}
                        edge="end"
                        fontSize="small"
                        mb={0}
                      />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <TextInput
                source="consigneePoNumber"
                label="Consignee PO Number"
                variant="outlined"
                fullWidth
                parse={(v) => v.toUpperCase()}
                disabled={record.status === OutboundStatus.RELEASED}
                onBlur={handleReferenceNumberBlur(
                  "consigneePoNumber",
                  "normalizedConsigneePoNumber",
                )}
                error={isOutboundDuplicateReferenceField(
                  duplicateReferenceFields,
                  "consigneePoNumber",
                )}
                helperText={duplicateReferenceFieldHelperText(
                  duplicateReferenceFields,
                  "consigneePoNumber",
                )}
                FormHelperTextProps={{
                  component: "div",
                  style: isOutboundDuplicateReferenceField(
                    duplicateReferenceFields,
                    "consigneePoNumber",
                  )
                    ? { color: "#f44336" }
                    : undefined,
                }}
                inputProps={{ style: { textTransform: "uppercase" } }}
              />
            </Grid>
          </Grid>

          {isEmpty(formData.transfer) ? (
            <OutboundForm
              record={record}
              formData={formData}
              addressBook={addressBook}
              selectedAddress={selectedAddress}
              setSelectedAddress={setSelectedAddress}
              CarrierTypesReversed={CarrierTypesReversed}
              railEquipmentChoices={railEquipmentChoices}
              truckEquipmentChoices={truckEquipmentChoices}
              carrierEquipmentChoices={carrierEquipmentChoices}
              setCarrierEquipmentChoices={setCarrierEquipmentChoices}
              setIsContainerPickUp={setIsContainerPickUp}
              setShipmentLineItems={setShipmentLineItems}
              handleReferenceNumberBlur={handleReferenceNumberBlur}
              duplicateReferenceFields={duplicateReferenceFields}
              form={form}
              notify={notify}
              operatingAccount={operatingAccount}
              onAddressUpdated={handleAddressBookEntryUpdated}
              customFields={getCustomFieldsSection(formData)}
            />
          ) : (
            <>
              <TransferForm
                record={record}
                formData={formData}
                loading={loading}
                form={form}
              />
              {getCustomFieldsSection(formData)}
            </>
          )}

          <Grid container direction="row" spacing={2}>
            <Hidden smDown>
              <Grid item xs={6}>
                <FileInput
                  source="attachments"
                  label="ATTACHMENTS"
                  variant="outlined"
                  fullWidth
                  placeholder={
                    <p>
                      <AttachFileIcon fontSize="large" /> <br /> Drop files to
                      upload, or click to select.
                    </p>
                  }
                  accept={ACCEPTED_FILES}
                  multiple
                  maxFiles={MAX_FILES}
                  options={{ maxFiles: MAX_FILES }}
                  onChange={(value) =>
                    handleFileChange("attachments", value, form, notify)
                  }
                  helperText={false}
                >
                  <FileField source="src" title="title" target="_blank" />
                </FileInput>
              </Grid>
            </Hidden>
            <Grid item xs={12} md={6}>
              <FileInput
                source="bolFile"
                label="BOL FILE"
                variant="outlined"
                fullWidth
                placeholder={
                  <p>
                    <AttachFileIcon fontSize="large" /> <br /> Create BOL, or
                    drop a File to upload, or click to select.
                  </p>
                }
                accept={ACCEPTED_FILES}
                onChange={(value) =>
                  handleFileChange("bolFile", value, form, notify)
                }
                disabled={false}
                helperText={false}
              >
                <FileField source="src" title="title" download />
              </FileInput>
            </Grid>
            {record.status !== OutboundStatus.ADVICE_PENDING && (
              <Hidden smDown>
                <Grid item xs={12}>
                  <PhotoInput
                    source="photos.items"
                    label="PHOTOS"
                    maxFiles={MAX_PHOTO_NUM_OUTBOUND}
                    parentType={ResourceType.OUTBOUND}
                    storeDir={`${FilePaths.OUTBOUND}/${Date.now()}`}
                    photos={photos}
                    setPhotos={setPhotos}
                  />
                </Grid>
              </Hidden>
            )}
          </Grid>
        </Grid>
      )}
    </FormDataConsumer>
  );
};

const OutboundForm = ({
  record,
  formData,
  addressBook,
  selectedAddress,
  setSelectedAddress,
  CarrierTypesReversed,
  railEquipmentChoices,
  truckEquipmentChoices,
  carrierEquipmentChoices,
  setCarrierEquipmentChoices,
  setIsContainerPickUp,
  setShipmentLineItems,
  handleReferenceNumberBlur,
  duplicateReferenceFields,
  form,
  notify,
  operatingAccount,
  onAddressUpdated,
  customFields,
}) => {
  const getPickupNumberHelperText = () => {
    const dupMsg = duplicateReferenceFieldHelperText(
      duplicateReferenceFields,
      "pickupNumber",
    );
    if (dupMsg) return dupMsg;
    if (operatingAccount?.generatePickupNumber) return "Auto-generated";
    return false;
  };

  const handleCarrierTypeChange = (event) => {
    const carrier = event?.target?.value;

    if (carrier === CarrierType.RAIL) {
      setCarrierEquipmentChoices(railEquipmentChoices);
    } else if (carrier === CarrierType.TRUCK) {
      setCarrierEquipmentChoices(truckEquipmentChoices);
    } else {
      setCarrierEquipmentChoices([]);
    }
    form.change("carrierEquipmentTypeId", "");

    if (carrier !== CarrierType.TRUCK) {
      // Only trucking companies are Carrier records, so a rail load has no id to
      // hold. Left behind, it would keep pointing at the trucking company while
      // the free-text field the rail branch renders renames the load out from
      // under it.
      form.change("carrierId", null);
      form.change("mustTarp", false);
      form.change("containerPickup", false);
      form.change("skipSignature", true);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <SelectInput
          source="carrierType"
          label="Carrier Type"
          variant="outlined"
          fullWidth
          disabled={record.status === OutboundStatus.RELEASED}
          choices={CarrierTypesReversed}
          onChange={handleCarrierTypeChange}
          validate={validateRequired}
          helperText={false}
        />
      </Grid>
      {(railEquipmentChoices?.length > 0 ||
        truckEquipmentChoices?.length > 0) && (
        <Grid item xs={12} md={4}>
          <SelectInput
            source="carrierEquipmentTypeId"
            label="Carrier Equipment Type"
            choices={carrierEquipmentChoices}
            allowEmpty
            fullWidth
            disabled={!carrierEquipmentChoices?.length}
            variant="outlined"
            helperText={false}
          />
          <SmartTipIcon label="carrier-equipment-type" mt={-1} />
        </Grid>
      )}
      <Grid item xs={12} sm={6} md={4}>
        {/* Only trucking companies exist as Carrier records, so only a truck load
            has a list to pick from. A rail carrier name is the railroad's mark —
            free text with no record behind it — and it stays a plain field. */}
        {formData.carrierType === CarrierType.TRUCK ? (
          <CarrierNameInput
            source="carrierName"
            label="Carrier Name"
            disabled={
              record.carrierName && record.status === OutboundStatus.RELEASED
            }
            validate={validateCarrierName}
            isRequired={isCarrierNameRequired(formData)}
          />
        ) : (
          <TextInput
            source="carrierName"
            label="Carrier Name"
            variant="outlined"
            fullWidth
            disabled={
              record.carrierName && record.status === OutboundStatus.RELEASED
            }
            validate={validateCarrierName}
            isRequired={isCarrierNameRequired(formData)}
            helperText={false}
          />
        )}
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextInput
          source="railCarNumber"
          label={
            formData.carrierType === CarrierType.RAIL
              ? "Railcar Number"
              : "Trailer Number"
          }
          variant="outlined"
          fullWidth
          disabled={
            record.railCarNumber && record.status === OutboundStatus.RELEASED
          }
          parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
          validate={validateRailCarNumber}
          required={isRailcarNumberRequired(formData)}
          helperText={false}
          inputProps={{ style: { textTransform: "uppercase" } }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CopyToClipboardButton
                  text={formData.railCarNumber || ""}
                  edge="end"
                  fontSize="small"
                  mb={0}
                />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      {formData.carrierType === CarrierType.TRUCK && (
        <Grid item xs={12} sm={6} md={4}>
          <TextInput
            source="pickupNumber"
            label="Pickup Number"
            variant="outlined"
            fullWidth
            parse={(v) => v.toUpperCase()}
            validate={validateRequired}
            disabled={
              operatingAccount?.generatePickupNumber ||
              record.status === OutboundStatus.RELEASED
            }
            onBlur={handleReferenceNumberBlur(
              "pickupNumber",
              "normalizedPickupNumber",
            )}
            error={isOutboundDuplicateReferenceField(
              duplicateReferenceFields,
              "pickupNumber",
            )}
            helperText={getPickupNumberHelperText()}
            FormHelperTextProps={{
              component: "div",
              style: isOutboundDuplicateReferenceField(
                duplicateReferenceFields,
                "pickupNumber",
              )
                ? { color: "#f44336" }
                : undefined,
            }}
            inputProps={{ style: { textTransform: "uppercase" } }}
          />
        </Grid>
      )}

      {customFields && (
        <Grid item xs={12}>
          {customFields}
        </Grid>
      )}
      <Grid item xs={12}>
        <fieldset>
          <legend>
            <Typography variant="overline" color="textSecondary">
              Options
            </Typography>
          </legend>
          <Grid container direction="row" spacing={0}>
            <Grid item xs={6} md={3}>
              <RadioButtonGroupInput
                source="mustTarp"
                label="Must Tarp?"
                row
                validate={
                  formData?.carrierType === CarrierType.TRUCK
                    ? validateRequired
                    : undefined
                }
                choices={TrueOrFalse}
                onChange={(value) =>
                  handleMustTarpChange(
                    value,
                    form,
                    setIsContainerPickUp,
                    setShipmentLineItems,
                    notify,
                  )
                }
                disabled={
                  record.status === OutboundStatus.RELEASED ||
                  formData?.carrierType !== CarrierType.TRUCK
                }
                helperText={false}
              />
            </Grid>
            <Grid item xs={6} md={3} style={{ display: "flex" }}>
              <RadioButtonGroupInput
                source="containerPickup"
                label="ISOtainer Pickup"
                row
                choices={TrueOrFalse}
                onChange={(value) =>
                  handleContainerPickupChange(
                    value,
                    form,
                    operatingAccount,
                    setIsContainerPickUp,
                    setShipmentLineItems,
                    notify,
                  )
                }
                defaultValue={false}
                validate={validateRequired}
                disabled={
                  record.status === OutboundStatus.RELEASED ||
                  formData?.carrierType !== CarrierType.TRUCK
                }
                helperText={false}
              />
              <BetaBadge />
            </Grid>
            <Grid item xs={6} md={3}>
              <RadioButtonGroupInput
                source="skipSignature"
                label="Skip e-signatures"
                row
                choices={TrueOrFalse}
                validate={validateRequired}
                disabled={
                  record.status === OutboundStatus.RELEASED ||
                  formData?.carrierType !== CarrierType.TRUCK
                }
                helperText={false}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <RadioButtonGroupInput
                source="skipInvoice"
                label="Skip Billing"
                row
                choices={TrueOrFalse}
                defaultValue={false}
                disabled={Boolean(record?.invoiceId?.trim())}
                validate={validateRequired}
                helperText={false}
              />
            </Grid>
          </Grid>
        </fieldset>
      </Grid>
      <Grid item xs={12}>
        <fieldset>
          <legend>
            <Typography variant="overline" color="textSecondary">
              Consignee Address
            </Typography>
          </legend>
          {record.status !== OutboundStatus.RELEASED && (
            <AddressBookSelect
              addressBook={addressBook}
              form={form}
              formData={formData}
              selectedAddress={selectedAddress}
              setSelectedAddress={setSelectedAddress}
              onAddressUpdated={onAddressUpdated}
            />
          )}
          <AddressInput
            source="shipTo"
            variant="outlined"
            fullWidth
            showBusinessName={true}
            showPhone={true}
            parse={(v) => (v !== "" ? v : undefined)}
            disabled={
              Boolean(selectedAddress) ||
              record.status === OutboundStatus.RELEASED
            }
            allValues={formData}
          />
          {!selectedAddress &&
            getSaveAddressControl(
              addressBook,
              null, // account = operatingAccount address book handled via addressBook state
              formData,
            )}
        </fieldset>
      </Grid>
      <Grid item xs={10}>
        <TextInput
          source="instructions"
          label="Special Instructions"
          variant="outlined"
          multiline
          fullWidth
        />
      </Grid>
      {/* <Grid item xs={2}>{getChecklist(formData)}</Grid> */}
    </Grid>
  );
};

const TransferForm = ({ record, formData, loading, form }) => {
  const handleTransferToAccountChange = (selectedAccount) => {
    form.change("transferToAccountName", selectedAccount?.businessName || "");
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography gutterBottom variant="overline" color="textSecondary">
          Destination Account
        </Typography>
        <Typography gutterBottom variant="body2">
          An "External Transfer" removes goods from inventory and transfers to
          selected account.
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <AccountDropDown
          source="transferToAccountId"
          label="To Account"
          excludeAccountIds={record?.accountId ? [record.accountId] : []}
          allowEmpty={false}
          onAccountChange={handleTransferToAccountChange}
          loading={loading}
          disabled={formData.status === OutboundStatus.RELEASED}
          validate={validateRequired}
          helperText={false}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <RadioButtonGroupInput
          source="skipInvoice"
          label="Skip Billing"
          row
          choices={TrueOrFalse}
          defaultValue={false}
          disabled={Boolean(record?.invoiceId?.trim())}
          validate={validateRequired}
          style={{ marginTop: "0" }}
          helperText={false}
        />
      </Grid>
    </Grid>
  );
};

const RenderExceptionIcon = ({ record }) => {
  const classes = useStyles();

  const hasException = useMemo(() => {
    return record?.inventoryItems?.items?.some(
      (item) => item?.hasException || item?.barcodeException,
    );
  }, [record?.inventoryItems?.items]);

  if (hasException)
    return <ExceptionIcon fontSize="small" className={classes.icons} />;
  return null;
};

const PickListTab = ({
  record,
  operatingAccount,
  isContainerPickUp,
  shipmentLineItems,
  setShipmentLineItems,
  allInventories,
  setAllInventories,
  isLoaded,
  setIsLoaded,
  ...props
}) => {
  const form = useForm();
  const history = useHistory();
  const location = useLocation(); // used to refresh allInventories
  const notify = useNotify();
  const [weightError, setWeightError] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [chargeRules, setChargeRules] = useState([]);
  const [autoCharges, setAutoCharges] = useState([]);

  useEffect(() => {
    // fetch on open and refresh on InventorySearchDialog close
    if (record?.accountId && !isOpen) {
      getAllInventories(
        record.accountId,
        isContainerPickUp,
        setAllInventories,
        setIsLoaded,
        notify,
      );
    }
  }, [location, isOpen, isContainerPickUp, record?.accountId]);

  useEffect(() => {
    // All outbound charge rules for this account; MANUAL + applicability is filtered at render time
    // Charge rules come from effective billing account (billtoAccountId fallback accountId).
    let currentBillingAccountId = null;
    let isMounted = true;

    const fetchOutboundChargeRules = async (billingAccountId) => {
      if (!billingAccountId) {
        if (isMounted) setChargeRules([]);
        return;
      }
      try {
        const rules = await fetchOutboundBillingRules(billingAccountId);
        // Out-of-order guard: a slow response for a previously selected billing
        // account must not overwrite the current account's rules.
        if (isMounted && billingAccountId === currentBillingAccountId) {
          setChargeRules(rules);
        }
      } catch (error) {
        logError(
          "outboundShipments:OutboundEdit:PickListTab:manualChargeRules",
          error,
          false,
        );
        if (isMounted && billingAccountId === currentBillingAccountId) {
          setChargeRules([]);
        }
      }
    };

    const getFormBillingAccountId = (values = {}) =>
      values?.billToAccountId || record?.billToAccountId || record?.accountId;

    currentBillingAccountId = getFormBillingAccountId(form.getState().values);
    fetchOutboundChargeRules(currentBillingAccountId);

    const unsubscribe = form.subscribe(
      ({ values }) => {
        const nextBillingAccountId = getFormBillingAccountId(values);
        if (nextBillingAccountId !== currentBillingAccountId) {
          currentBillingAccountId = nextBillingAccountId;
          fetchOutboundChargeRules(nextBillingAccountId);
        }
      },
      { values: true },
    );

    return () => {
      isMounted = false;
      unsubscribe();
    };
  }, [record?.billToAccountId, record?.accountId]);

  useEffect(() => {
    // Subscribe to form changes to calculate auto charges, est. net weight and total quantity
    const unsubscribe = form.subscribe(
      ({ values }) => {
        const outbound = values ?? record;
        setAutoCharges(getAutoCharges(outbound, chargeRules));
        const weightUOM = outbound.weightUnits || outbound.scaleWeightUnits;
        const net = calcNetWeight(outbound, setWeightError, weightUOM);
        const nextNetWeight = net != null ? net : null;
        if (outbound?.netWeight !== nextNetWeight) {
          form.change("netWeight", nextNetWeight);
        }
        if (weightUOM && outbound?.weightUnits !== weightUOM) {
          form.change("weightUnits", weightUOM);
        }
      },
      { values: true },
    );

    return () => unsubscribe();
  }, [chargeRules, form, record]);

  const defaultSort = { field: "sortKey", order: "ASC" };
  // Inventory custom-field definitions follow the operating account connection.
  const accountFields =
    (operatingAccount || record.account)?.inventoryCustomFields?.length > 0
      ? (operatingAccount || record.account).inventoryCustomFields
      : [];
  const customGridFields = accountFields
    ? accountFields.map((field, index) => {
        return (
          <CustomField
            source={`inventory.customFields[${index}]`}
            field={field}
            label={field.name}
            sortable={true}
          />
        );
      })
    : [];

  const updateShipmentLineItems = (shipmentItems) => {
    let defaultUOM = null;
    debugger;

    if (shipmentItems.length > 0) {
      form.change("areaId", shipmentItems[0].inventory.areaId);
      form.change("zoneId", shipmentItems[0].inventory.zoneId);

      shipmentItems.forEach((item) => {
        if (!defaultUOM && item.inventory.inventoryUOM)
          defaultUOM = item.inventory.inventoryUOM;
        else if (!defaultUOM)
          defaultUOM =
            item.inventory.inboundShipment.totalUOM ||
            item.inventory.inventoryUOM;
        if (defaultUOM) form.change("totalUOM", defaultUOM);
      });
    }

    setShipmentLineItems({ items: shipmentItems });
    form.change("shipmentLineItems.items", shipmentItems);
  };

  // Subscribe to field state updates for 3rd party inputs
  form.registerField(
    "shipmentLineItems",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );
  form.registerField(
    "shipmentLineItems.items",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { change, ...rest } = fieldState;
    },
    { dirty: true, touched: true, valid: true, value: true },
  );

  useEffect(() => {
    debugger;
    if (record.shipmentLineItems?.items)
      setShipmentLineItems(record.shipmentLineItems);
  }, [record?.shipmentLineItems?.items]);

  useEffect(() => {
    if (shipmentLineItems?.items !== record?.shipmentLineItems?.items) {
      handlePickListWeight(form, setWeightError);
    }
  }, [shipmentLineItems?.items]);

  const pickList = shipmentLineItems.items || [];
  const listContext = useList({
    ...props,
    data: pickList,
    ids: pickList.map(({ id }) => id),
    loaded: true,
    sort: defaultSort,
  });

  return (
    <FormDataConsumer>
      {({ formData, ...rest }) => (
        <Grid container spacing={0}>
          <Grid item xs={12}>
            <ListContextProvider value={listContext}>
              <CustomizableDatagrid
                label="PICK LIST:"
                hasBulkActions={false}
                rowClick="expand"
                expand={
                  <InventoryItemsEditGridInput
                    inventories={shipmentLineItems}
                    setInventories={updateShipmentLineItems}
                  />
                }
                storageProp={`OutboundShipmentLineItems_${record.accountId}_large`}
                defaultColumns={[
                  "inventory.productName",
                  "lotNumber",
                  // "inventory.quantityOnHand",
                  // "inventory.quantityCommitted",
                  "inventory.quantityAvaiable",
                  "totalQuantityToPick",
                  "totalQuantityReturned",
                  "netQuantity",
                  "inventory.inventoryUOM",
                ]}
              >
                {[
                  <FunctionField
                    source="inventory.productName"
                    label="Product Name"
                    sortable={true}
                    render={(record) =>
                      record?.inventory && (
                        <>
                          <RenderExceptionIcon record={record} />
                          {record.inventory.productName}
                          {getInfoBubble(formData, record)}{" "}
                        </>
                      )
                    }
                  />,
                  <FunctionField
                    source="pcs"
                    label="PPU"
                    render={piecesRenderer}
                  />,
                  <TextField source="lotNumber" label="Lot Number" />,
                  <TextField source="inventory.poNumber" label="PO Number" />,
                  <NumberField
                    source="inventory.quantityOnHand"
                    label="Qty. On Hand"
                  />,
                  <NumberField
                    source="inventory.quantityCommitted"
                    label="Qty. Committed"
                  />,
                  <FunctionField
                    source="inventory.quantityAvaiable"
                    label="Qty. Available"
                    sortable={false}
                    render={(record) =>
                      record &&
                      `${trimDecimal(
                        record.inventory?.quantityOnHand -
                          record.inventory?.quantityCommitted,
                        3,
                      )}`
                    }
                  />,
                  <NumberField
                    source="totalQuantityToPick"
                    label="Qty. Outbound"
                  />,
                  <FunctionField
                    source="totalPiecesToPick"
                    label="Total PCS"
                    render={totalToPickPiecesRenderer}
                  />,
                  <NumberField
                    source="totalQuantityReturned"
                    label="Qty. Returned"
                  />,
                  <FunctionField
                    source="netQuantity"
                    label="Net Qty"
                    sortable={false}
                    render={(record) => {
                      const shipped = Number(record?.totalQuantityToPick || 0);
                      const returned = Number(
                        record?.totalQuantityReturned || 0,
                      );
                      return trimDecimal(Math.max(0, shipped - returned), 3);
                    }}
                  />,
                  <TextField source="inventory.inventoryUOM" label="UOM" />,
                  ...customGridFields,
                  <ShipmentItemEditActionButtons
                    {...props}
                    form={form}
                    outbound={record}
                    history={history}
                    inventories={shipmentLineItems}
                    setInventories={updateShipmentLineItems}
                  />,
                ]}
              </CustomizableDatagrid>
            </ListContextProvider>
          </Grid>
          <Grid item xs={12}>
            <Button
              label="Add"
              color="default"
              onClick={() => setIsOpen(true)}
              disabled={
                record.status === OutboundStatus.LOADED ||
                record.status === OutboundStatus.RELEASED
              }
            >
              <AddIcon />
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="overline" color="textSecondary">
              Total Load
            </Typography>
            <Grid container direction="row" spacing={1}>
              <Grid item xs={6} md={3}>
                <MuiTextField
                  label="Total Quantity"
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  disabled
                  value={calcTotalQuantity(formData) ?? ""}
                  InputProps={{ endAdornment: formData.totalUOM }}
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <NumberInput
                  source="netWeight"
                  label="Est. Net Weight"
                  variant="outlined"
                  fullWidth
                  disabled
                  helperText={weightError ? weightError : false}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    endAdornment:
                      formData.scaleWeightUnits || formData.weightUnits || "",
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          {!formData?.skipInvoice && (
            <fieldset style={{ width: "100%" }}>
              <legend>
                <Typography variant="overline" color="textSecondary">
                  Billing <NewBadge />
                </Typography>
              </legend>

              <Grid container spacing={8}>
                <Grid item xs={12} md={6}>
                  <Typography variant="overline" color="textSecondary">
                    Auto Charges
                  </Typography>
                  <ArrayField
                    record={autoCharges}
                    source="items"
                    label={false}
                    fullWidth
                  >
                    <Datagrid>
                      <FunctionField
                        label="Service"
                        render={(record) => {
                          // Extract service name from serviceNote
                          const parts = record?.serviceNote?.split(" - ") || [];
                          return parts[0] || "";
                        }}
                      />
                      <FunctionField
                        label="Quantity"
                        render={(record) => {
                          const qty = Number(record?.quantity || 0);
                          const units = record?.units || "";
                          return qty ? `${qty} ${getUnitName(units)}` : "";
                        }}
                      />
                      <FunctionField
                        label="Est. Charge"
                        render={(record) => {
                          const amount = Number(record?.amount || 0);
                          return amount ? `$${amount.toFixed(2)}` : "";
                        }}
                      />
                    </Datagrid>
                  </ArrayField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="overline" color="textSecondary">
                    Manual Charges
                  </Typography>
                  <SmartTipIcon
                    label="manual-charges"
                    alignRight={false}
                    mt={20}
                  />
                  <ArrayInput
                    source="manualCharges.items"
                    label={false}
                    fullWidth
                    disabled={
                      !chargeRules?.length || Boolean(record?.invoiceId?.trim())
                    }
                  >
                    <SimpleFormIterator disableReordering={true}>
                      <FormDataConsumer>
                        {({ getSource, scopedFormData }) => {
                          const applicableRules = filterApplicableManualRules(
                            formData,
                            chargeRules,
                            ChargeEvent.OUTBOUND,
                          );
                          const selectedRule = applicableRules.find(
                            (rule) => rule.id === scopedFormData?.chargeRuleId,
                          );
                          const billingUOM = getUnitName(
                            selectedRule?.billingUOM,
                          );

                          return (
                            <Grid container direction="row" spacing={1}>
                              <Grid item xs={7}>
                                <SelectInput
                                  source={getSource("chargeRuleId")}
                                  label="Service"
                                  variant="outlined"
                                  fullWidth
                                  disabled={Boolean(record?.invoiceId?.trim())}
                                  helperText={false}
                                  choices={getManualRuleChoices(
                                    applicableRules,
                                    scopedFormData,
                                  )}
                                  onChange={(value) =>
                                    applyManualRuleDefaultQuantity({
                                      value,
                                      applicableRules,
                                      formData,
                                      scopedFormData,
                                      form,
                                      getSource,
                                    })
                                  }
                                />
                              </Grid>
                              <Grid item xs={5}>
                                <NumberInput
                                  source={getSource("quantity")}
                                  label="Quantity"
                                  variant="outlined"
                                  fullWidth
                                  min="0"
                                  validate={[required(), number(), minValue(0)]}
                                  disabled={Boolean(record?.invoiceId?.trim())}
                                  helperText={getManualChargeAmount(
                                    selectedRule,
                                    scopedFormData,
                                  )}
                                  InputProps={{
                                    endAdornment: billingUOM,
                                  }}
                                />
                              </Grid>
                            </Grid>
                          );
                        }}
                      </FormDataConsumer>
                    </SimpleFormIterator>
                  </ArrayInput>
                </Grid>
              </Grid>
            </fieldset>
          )}
          <InventorySearchDialog
            {...props}
            isContainerPickUp={isContainerPickUp}
            title="Inventory Search"
            form={form}
            account={record.account}
            allInventories={allInventories}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            isLoaded={isLoaded}
            setIsLoaded={setIsLoaded}
            updateShipment={updateShipmentLineItems}
          />
        </Grid>
      )}
    </FormDataConsumer>
  );
};

const AdviceDispatchTab = ({ record, ...props }) => {
  const form = useForm();
  debugger;

  // Subscribe to field state updates for 3rd party inputs
  form.registerField(
    "scheduledDateTime",
    (fieldState) => {
      // eslint-disable-next-line no-unused-vars
      const { blur, change, focus, ...rest } = fieldState;
    },
    { active: true, dirty: true, touched: true, valid: true, value: true },
  );

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <FormDataConsumer>
        {({ formData, ...rest }) => (
          <Grid container direction="column" spacing={1}>
            <Grid item xs={12} md={4}>
              <DateTimePicker
                label="Time Scheduled"
                margin="dense"
                inputVariant="outlined"
                variant="dialog"
                fullWidth
                disabled
                value={
                  !formData.scheduledDateTime
                    ? null
                    : formData.scheduledDateTime
                }
                format="MM/dd/yyyy hh:mm a"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <CreatedAtIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12}>
              {record.timeslot?.eventType && (
                <EventsCalendar
                  eventType={record.timeslot.eventType}
                  selectedTimeslot={record.timeslot}
                  disableClick={false}
                />
              )}
            </Grid>
          </Grid>
        )}
      </FormDataConsumer>
    </MuiPickersUtilsProvider>
  );
};

const DispatchTab = ({
  record,
  selectedTimeslot,
  setSelectedTimeslot,
  ...props
}) => {
  const form = useForm();
  const notify = useNotify();
  const isXSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const [weightError, setWeightError] = useState(false);
  const [openSeals, setOpenSeal] = useState(false);
  const [eventType, setEventType] = useState(record?.timeslot?.eventType);
  const [isSchedulerOpen, setIsSchedulerOpen] = useState(false);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const advancePrefill = props?.location?.state?.outboundAdvancePrefill;
  const [departedAt, setDepartedAt] = useState(
    record?.departureDateTime || null,
  );
  // Active driver gate check-in, if any. Only trucks check in at the gate, so
  // a rail form does not query for one, and neither does a yard that checks
  // trucks in at the office — it has no check-in rows to find and no gate
  // control to show. Pending status/dock edits live in the form
  // (gateCheckInEdit) and are persisted by the form's primary Save.
  const gateEnabled = sessionYardRunsDriverCheckIn();
  // A linked load (LTL "ship with") shares one row with its siblings, keyed
  // under whichever load the driver searched: every member's key is read, and
  // the shipment's own lock names the row first. A single load passes neither.
  const { checkIn: gateCheckIn, containerRef: gateContainerRef } =
    useActiveGateCheckIn(
      "out",
      gateEnabled && record?.carrierType === CarrierType.TRUCK
        ? record?.id
        : null,
      isLinked(record) ? record.shipWithIds : null,
      isLinked(record) ? record.gateCheckInId || null : null,
    );
  // A supervisor calls trucks in the published order. Placing a load says the
  // truck reached a dock, so the Time Placed picker below is bound by the same
  // rule as the gate status select — read once here and shared with the gate
  // control, which greys out the statuses the order forbids on this answer.
  const gateQueueTurn = useGateQueueTurn(gateCheckIn);
  const isPlacedBlockedByQueue = !canSetGateStatus({
    status: GateCheckInStatus.DOCKED,
    currentStatus: gateCheckIn?.status,
    orderBound: gateQueueTurn.orderBound,
    isNextInQueue: gateQueueTurn.isNextInQueue,
  });

  useEffect(() => {
    if (record?.timeslot) {
      setSelectedTimeslot(record.timeslot);
      setEventType(record.timeslot.eventType);
    }
  }, [record]);

  // These fields are edited through bare MUI pickers and custom controls, not
  // react-admin inputs, so nothing else registers them with final-form —
  // registration is what makes form.change() on them dirty the form and carry
  // into the submit values. Registered once with cleanup: the previous
  // inline registerField calls added a new subscriber on every render and
  // never released any.
  useEffect(() => {
    const noop = () => {};
    const unsubscribes = [
      "scheduledDateTime",
      "arrivalDateTime",
      "placementDateTime",
      "startDateTime",
      "endDateTime",
      "departureDateTime",
      "deliveryDateTime",
      "collectedDateTime",
      "yardSignatureKey",
      "carrierSignatureKey",
      "gateCheckInEdit",
    ].map((field) => form.registerField(field, noop, { value: true }));
    return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const initFromRecord = () => {
      if (record?.departureDateTime && !departedAt)
        setDepartedAt(record.departureDateTime);
    };
    initFromRecord();

    const applyPrefill = () => {
      if (!advancePrefill) return;
      if (advancePrefill.field === "arrivalDateTime") {
        if (!record?.arrivalDateTime) {
          handleArriveTime(advancePrefill.value);
        }
      } else if (advancePrefill.field === "placementDateTime") {
        if (!record?.placementDateTime) {
          handlePlaceTime(advancePrefill.value, record);
        }
      } else if (advancePrefill.field === "departureDateTime") {
        if (!record?.departureDateTime) {
          setDepartedAt(advancePrefill.value);
          form.change("departureDateTime", advancePrefill.value);
        }
      }
    };
    applyPrefill();
    const t = setTimeout(applyPrefill, 0);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record, advancePrefill]);

  const handlePlaceTime = (value, formData) => {
    form.change("placementDateTime", value);
    if (!value || value === "") {
      if (formData.tareWeight) form.change("tareWeight", null);
      if (formData.startDateTime) form.change("startDateTime", value);
      if (formData.endDateTime) form.change("endDateTime", value);
    }
    // A placed load is at the dock — advance the pending gate status with the
    // stamp. Only forward from the waiting statuses so editing the placed time
    // never downgrades a check-in already completed or cancelled.
    if (value && value !== "") setGateStatusForward(GateCheckInStatus.DOCKED);
  };

  // Un-arriving un-places: a load that never arrived cannot be placed, and
  // the save path re-fills a missing arrival from the placed time, so a
  // cleared arrival only sticks (and derives PENDING) when the placed time
  // goes with it — which also cascades to the loading fields placed owns.
  const handleArriveTime = (value, formData) => {
    form.change("arrivalDateTime", value);
    if ((!value || value === "") && formData?.placementDateTime)
      handlePlaceTime(value, formData);
  };

  // The Time Released picker's enablement, in one place: the gate's COMPLETED
  // stamp must refuse exactly what the picker refuses, or a manager reads a
  // picker they can fill by hand while the gate silently declines to fill it.
  // DO NOT CHANGE OR INVENTORY COUNTS WILL BE INCONSISTENT ON STATUS ROLLBACK !!!
  const isReleasedTimeDisabled = (formData) =>
    (!record.placementDateTime && !formData.placementDateTime) ||
    !formData.endDateTime ||
    formData.shipmentLineItems?.items?.length === 0 ||
    record.state !== OutboundState.COMPLETED ||
    record.status === OutboundStatus.RELEASED;

  const {
    setGateEdit,
    setGateStatusForward,
    startManualGateCheckIn,
    handleGateStatus,
    handleGateDock,
    handleGateAtDock,
  } = createStagedGateEdit({
    form,
    gateCheckIn,
    notify,
    fields: {
      arrivalField: "arrivalDateTime",
      placedField: "placementDateTime",
      setArrival: handleArriveTime,
      setPlaced: handlePlaceTime,
      // Past spotting already: loading finished or the truck has left.
      isAtDockBlocked: (formData) =>
        Boolean(
          formData.placementDateTime ||
          formData.endDateTime ||
          formData.departureDateTime,
        ),
      // The gate rule the crew Gate Queue and saveGateCheckIn apply — carrier
      // name and trailer number — so DOCKED is refused here for exactly the
      // shipments they refuse to place. The record is merged under the form
      // values because the form only holds what its own tabs put there.
      atDockRefusalReason: (formData) =>
        gatePlacementRefusal({ ...record, ...formData }, true),
      canStampRelease: (formData) =>
        !formData.departureDateTime && !isReleasedTimeDisabled(formData),
      // The load as the departure rule sees it: the form only holds what its
      // own tabs put there, so the record sits under the form values.
      shipmentOf: (formData) => ({ ...record, ...formData }),
      setRelease: (stamp) => {
        setDepartedAt(stamp);
        form.change("departureDateTime", stamp);
      },
    },
  });

  const handleStartTime = (value, formData) => {
    form.change("startDateTime", value);

    if (!value || value === "") {
      if (formData.endDateTime) form.change("endDateTime", value);
    }
  };

  const handleEndTime = (value) => {
    form.change("endDateTime", value);

    if (!value || value === "") {
      form.change("startDateTime", value);
    }
  };

  const getActualGross = (outbound) => {
    if (
      outbound.tareWeight !== null &&
      outbound.tareWeight >= 0 &&
      outbound.ladenWeight
    ) {
      return `Gross Weight: ${outbound.ladenWeight - outbound.tareWeight} ${
        outbound.weightUnits ? outbound.weightUnits : outbound.scaleWeightUnits
      }`;
    } else return true;
  };

  const handleScaleUnitsChange = (event, formData) => {
    const netWeight = calcNetWeight(
      formData,
      setWeightError,
      event.target.value,
    );
    form.change("netWeight", netWeight != null ? netWeight : null);
    form.change("weightUnits", event.target.value || null);
  };

  const handleTimeslot = (timeslot) => {
    if (timeslot) {
      const scheduledDate = resolveScheduledDateTime(timeslot, {
        notify,
        scope: "outboundShipments:OutboundEdit:DispatchTab:handleTimeslot",
      });
      if (!scheduledDate) return;
      form.change("scheduledDateTime", scheduledDate);
      setSelectedTimeslot(timeslot);
      if (timeslot.eventType) setEventType(timeslot.eventType);
    } else {
      form.change("scheduledDateTime", null);
      setSelectedTimeslot(null);
    }
  };

  // Once the driver has arrived at the gate or the load is placed, the
  // appointment is history — no rescheduling either way.
  const isPastScheduling = (formData) =>
    Boolean(formData.arrivalDateTime || formData.placementDateTime);

  const handleSchedulerOpen = (event, formData) => {
    event.preventDefault();
    event.stopPropagation();
    if (!isPastScheduling(formData)) setIsSchedulerOpen(true);
  };

  const getSchedulerHelperText = (formData) => {
    if (!window.appUser.reloadYard.eventTypes?.items?.length)
      return `Setup Schedule and Event Type to enable.`;
    if (isPastScheduling(formData))
      return "Arrived shipments cannot be rescheduled.";
    // One truck, one appointment: the lambda books every load of a linked
    // group together (AD-2, AD-3), so the manager is told before they pick.
    if (isLinked(record))
      return [eventType?.name, "Linked loads are scheduled together."]
        .filter(Boolean)
        .join(" ");
    return eventType?.name || "";
  };

  const handleOpen = () => {
    setOpenSeal(true);
  };
  const handleClose = () => {
    setOpenSeal(false);
  };
  const getSealNumberButtonLabel = (formData) => {
    return `Seals (${formData?.seals?.items.length || 0})`;
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <FormDataConsumer>
        {({ formData, ...rest }) => (
          <Grid container direction="column" spacing={1}>
            <Grid container direction="row" spacing={2}>
              <Grid
                item
                xs={12}
                md={4}
                style={{ display: "flex", alignItems: "flex-start", gap: 8 }}
              >
                <DateTimePicker
                  label="Time Scheduled"
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  fullWidth
                  disabled={isPastScheduling(formData)}
                  onClickCapture={(event) =>
                    handleSchedulerOpen(event, formData)
                  }
                  value={
                    !formData.scheduledDateTime
                      ? null
                      : getDateTimeFromUtc(formData.scheduledDateTime)
                  }
                  format="MM/dd/yyyy hh:mm a"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <CreatedAtIcon />
                      </InputAdornment>
                    ),
                  }}
                  onChange={() => {}}
                  helperText={getSchedulerHelperText(formData)}
                />
                <Box mt={0.5}>
                  <IconButtonWithTooltip
                    label="Calendar"
                    color="default"
                    size="large"
                    onClick={() => setIsCalendarOpen(true)}
                  >
                    <CalendarIcon />
                  </IconButtonWithTooltip>
                </Box>
                <Scheduler
                  account={record.account}
                  eventType={eventType}
                  setEventType={setEventType}
                  selectedTimeslot={selectedTimeslot}
                  setSelectedTimeslot={handleTimeslot}
                  open={isSchedulerOpen}
                  setIsOpen={setIsSchedulerOpen}
                  resettable={true}
                  workflow={Workflow.OUTBOUND}
                />
                {isCalendarOpen && (
                  <EventsCalendarDialog
                    eventType={eventType}
                    selectedTimeslot={selectedTimeslot}
                    persistedTimeslotId={record?.timeslot?.id}
                    account={record.account}
                    onTimeslotPick={handleTimeslot}
                    isOpen={isCalendarOpen}
                    setIsOpen={setIsCalendarOpen}
                  />
                )}
              </Grid>
              {/* Manage the driver's gate check-in without leaving the form
                  for the Gate Queue page, and check a truck in from here when
                  the driver could not do it from the kiosk. Only trucks check
                  in at the gate, so a rail form does not query for one, and a
                  yard that checks trucks in at the office runs no gate at all.
                  The record is merged under the form values for the same
                  reason DialogSaveButton merges it before minting the row: the
                  form only holds what its own tabs put there. */}
              <Grid item xs={12} md={8}>
                {gateEnabled && formData.carrierType === CarrierType.TRUCK && (
                  <GateCheckInControl
                    checkIn={gateCheckIn}
                    containerRef={gateContainerRef}
                    onAtDock={handleGateAtDock}
                    queueTurn={gateQueueTurn}
                    shipment={{ ...record, ...formData }}
                    manualCheckIn={{
                      pending: wantsManualGateCheckIn(
                        { ...record, ...formData },
                        true,
                      ),
                      onCheckIn: canOfferManualGateCheckIn(
                        { ...record, ...formData },
                        true,
                      )
                        ? startManualGateCheckIn
                        : null,
                    }}
                    editor={{
                      status:
                        formData.gateCheckInEdit?.status ??
                        gateCheckIn?.status ??
                        "",
                      dock:
                        formData.gateCheckInEdit?.dockAssignment ??
                        gateCheckIn?.dockAssignment ??
                        "",
                      driverName:
                        formData.gateCheckInEdit?.driverName ??
                        gateCheckIn?.driverName ??
                        "",
                      truckPlate:
                        formData.gateCheckInEdit?.truckPlate ??
                        gateCheckIn?.truckPlate ??
                        "",
                      setStatus: handleGateStatus,
                      setDock: handleGateDock,
                      setDriverName: (value) =>
                        setGateEdit({ driverName: value }),
                      setTruckPlate: (value) =>
                        setGateEdit({ truckPlate: value }),
                    }}
                  />
                )}
              </Grid>
            </Grid>

            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={4}>
                <DateTimePicker
                  label="Time Arrived"
                  fullWidth
                  disableFuture
                  showTodayButton
                  clearable
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  disabled={
                    record.status === OutboundStatus.LOADED ||
                    record.status === OutboundStatus.RELEASED
                  }
                  value={
                    !formData.arrivalDateTime ? null : formData.arrivalDateTime
                  }
                  onChange={(value) => handleArriveTime(value, formData)}
                  maxDate={formData.placementDateTime || undefined}
                  maxDateMessage="Date should be before Placed Time"
                  format="MM/dd/yyyy hh:mm a"
                  helperText="Stamped by driver gate check-in, or set manually."
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <ArrivedAtIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {formData.carrierType === CarrierType.TRUCK &&
                isEmpty(formData.transfer) && (
                  <Grid item xs={12} sm={6} md={4}>
                    <CarrierNameInput
                      source="carrierName"
                      label="Carrier Name"
                      disabled={
                        record.carrierName &&
                        record.status === OutboundStatus.RELEASED
                      }
                      validate={validateCarrierName}
                      isRequired={isCarrierNameRequired(formData)}
                    />
                  </Grid>
                )}
              {formData.carrierType === CarrierType.TRUCK &&
                isEmpty(formData.transfer) && (
                  <Grid item xs={12} md={4}>
                    <TextInput
                      source="railCarNumber"
                      label="Trailer Number"
                      variant="outlined"
                      fullWidth
                      disabled={
                        record.railCarNumber &&
                        record.status === OutboundStatus.RELEASED
                      }
                      parse={(v) => (v !== "" ? v.toUpperCase() : undefined)}
                      validate={validateRailCarNumber}
                      required={isRailcarNumberRequired(formData)}
                      inputProps={{ style: { textTransform: "uppercase" } }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <CopyToClipboardButton
                              text={formData.railCarNumber || ""}
                              edge="end"
                              fontSize="small"
                              mb={0}
                            />
                          </InputAdornment>
                        ),
                      }}
                      helperText={false}
                    />
                  </Grid>
                )}
            </Grid>

            {record.status !== OutboundStatus.ADVICE_PENDING && (
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={4}>
                  <DateTimePicker
                    label="Time Placed"
                    fullWidth
                    disableFuture
                    showTodayButton
                    clearable
                    margin="dense"
                    inputVariant="outlined"
                    variant="dialog"
                    disabled={
                      record.status === OutboundStatus.LOADED ||
                      record.status === OutboundStatus.RELEASED ||
                      // A truck that has not been called forward is not at a
                      // dock. Stamping this field advances the gate row to
                      // DOCKED, which the queue would refuse at the save — so
                      // the refusal is shown here instead of after the work.
                      isPlacedBlockedByQueue
                    }
                    {...(isPlacedBlockedByQueue && {
                      // Red text behind a warning glyph, matching the overdue
                      // account warning on AccountDropDown. Spread only when
                      // blocked: error/helperText passed as undefined would
                      // clobber the picker's own min/maxDateMessage text.
                      error: true,
                      helperText: `⚠️ ${outOfTurnTooltip(
                        gateQueueTurn.nextLabel,
                      )}`,
                    })}
                    value={formData.placementDateTime || null}
                    onChange={(value) => handlePlaceTime(value, formData)}
                    minDate={formData.arrivalDateTime || undefined}
                    minDateMessage="Date should be after Arrival Time"
                    maxDate={formData.departureDateTime || undefined}
                    maxDateMessage="Date should be before Released Time"
                    format="MM/dd/yyyy hh:mm a"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <PlacedAtIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                {formData.carrierType === CarrierType.TRUCK &&
                  isEmpty(formData.transfer) && (
                    <>
                      <Grid item xs={12} md={4}>
                        <NumberInput
                          source="tareWeight"
                          label="Tare Weight"
                          variant="outlined"
                          fullWidth
                          disabled={
                            Boolean(record?.invoiceId?.trim()) ||
                            (isBulkCommodity(
                              record?.shipmentLineItems?.items[0]?.inventory
                                ?.reloadYardCommodityId,
                            ) &&
                              record.status === OutboundStatus.RELEASED)
                          }
                          min="0"
                          validate={(value, allValues) =>
                            allValues.ladenWeight
                              ? validateTareWeight(value)
                              : validateEmptyMinNum(value)
                          }
                          required={isTareWeightRequired(formData)}
                          helperText={false}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">{`${
                                formData.scaleWeightUnits || ""
                              }`}</InputAdornment>
                            ),
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <SelectInput
                          source="scaleWeightUnits"
                          label="Weight Units"
                          variant="outlined"
                          fullWidth
                          disabled={
                            Boolean(record?.invoiceId?.trim()) ||
                            formData.shipmentLineItems?.items?.length === 0
                          }
                          choices={UnitWeightOptions}
                          optionText={unitOptionRenderer}
                          allowEmpty
                          // defaultValue={Unit.CWT} -- removing to keep form pristine
                          validate={
                            formData.tareWeight || formData.ladenWeight
                              ? validateRequired
                              : undefined
                          }
                          onChange={(event) =>
                            handleScaleUnitsChange(event, formData)
                          }
                          helperText={false}
                        />
                      </Grid>
                    </>
                  )}
              </Grid>
            )}
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={4}>
                <DateTimePicker
                  label="Load Start Time"
                  fullWidth
                  disableFuture
                  showTodayButton
                  clearable
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  disabled={
                    !formData.startDateTime ||
                    record.status === OutboundStatus.RELEASED
                  }
                  value={
                    formData.startDateTime === ""
                      ? null
                      : formData.startDateTime
                  }
                  onChange={(value) => handleStartTime(value, formData)}
                  minDate={
                    formData.placementDateTime || formData.arrivalDateTime
                  }
                  minDateMessage="Date should be after Placed Time"
                  format="MM/dd/yyyy hh:mm a"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <TimerIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={4}>
                <DateTimePicker
                  label="Load End Time"
                  fullWidth
                  disableFuture
                  showTodayButton
                  clearable
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  disabled={
                    !formData.endDateTime ||
                    record.status === OutboundStatus.RELEASED
                  }
                  value={
                    formData.endDateTime === "" ? null : formData.endDateTime
                  }
                  onChange={(value) => handleEndTime(value)}
                  minDate={formData.startDateTime}
                  minDateMessage="Date should be after Start Time"
                  format="MM/dd/yyyy hh:mm a"
                  helperText={getHoursMinutesDuration(
                    "Load Time:",
                    formData.startDateTime,
                    formData.endDateTime,
                  )}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <TimerOffIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {formData.carrierType === CarrierType.TRUCK &&
                isEmpty(formData.transfer) && (
                  <>
                    <Grid item xs={12} md={4}>
                      <NumberInput
                        source="ladenWeight"
                        label="Laden Weight"
                        variant="outlined"
                        fullWidth
                        disabled={
                          Boolean(record?.invoiceId?.trim()) ||
                          record.state !== OutboundState.COMPLETED ||
                          (isBulkCommodity(
                            record?.shipmentLineItems?.items[0]?.inventory
                              ?.reloadYardCommodityId,
                          ) &&
                            record.status === OutboundStatus.RELEASED)
                        }
                        min="0"
                        validate={validateLadenWeight}
                        required={isLadenWeightRequired(formData)}
                        helperText={getActualGross(formData)}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">{`${
                              formData.scaleWeightUnits || ""
                            }`}</InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <NumberInput
                        source="netWeight"
                        label="Net Weight"
                        variant="outlined"
                        fullWidth
                        disabled
                        helperText={weightError ? weightError : false}
                        inputLabelProps={{ shrink: true }}
                        InputProps={{
                          endAdornment: formData.scaleWeightUnits || "",
                        }}
                      />
                    </Grid>
                  </>
                )}
            </Grid>

            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={4}>
                <DateTimePicker
                  label="Time Released"
                  fullWidth
                  disableFuture
                  showTodayButton
                  clearable
                  margin="dense"
                  inputVariant="outlined"
                  variant="dialog"
                  // DO NOT CHANGE OR INVENTORY COUNTS WILL BE INCONSISTENT ON STATUS ROLLBACK !!!
                  disabled={isReleasedTimeDisabled(formData)}
                  value={departedAt || null}
                  onChange={(value) => {
                    setDepartedAt(value);
                    form.change("departureDateTime", value);
                    // A released load has left the gate too.
                    if (value) setGateStatusForward(GateCheckInStatus.DEPARTED);
                  }}
                  minDate={formData.endDateTime}
                  minDateMessage="Date should be after Load End Time"
                  format="MM/dd/yyyy hh:mm a"
                  helperText={getHoursMinutesDuration(
                    "Cycle Time:",
                    formData.arrivalDateTime || formData.placementDateTime,
                    formData.departureDateTime,
                  )}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <ReleasedAtIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              {!formData?.skipSignature &&
                formData.carrierType === CarrierType.TRUCK &&
                isAuthorized(AclType.OUTBOUND_SIGN) &&
                !isXSmall && (
                  <SignatureBlock
                    formData={formData}
                    form={form}
                    record={record}
                    updateShipmentMini={updateLambdaOutboundMini}
                  />
                )}
            </Grid>
            {record.carrierType === CarrierType.RAIL && (
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12} md={4}>
                  <DateTimePicker
                    label="Time Pulled"
                    disableFuture
                    showTodayButton
                    clearable
                    margin="dense"
                    inputVariant="outlined"
                    variant="dialog"
                    fullWidth
                    // DO NOT CHANGE OR INVENTORY COUNTS WILL BE INCONSISTENT ON STATUS ROLLBACK !!!
                    disabled={
                      !formData.departureDateTime ||
                      formData.departureDateTime === ""
                    }
                    value={
                      !formData.collectedDateTime ||
                      formData.collectedDateTime === ""
                        ? null
                        : formData.collectedDateTime
                    }
                    minDate={formData.departureDateTime}
                    minDateMessage="Date should be after Released Time"
                    format="MM/dd/yyyy hh:mm a"
                    onChange={(value) =>
                      form.change("collectedDateTime", value)
                    }
                    // Placed through pulled, both days counted.
                    helperText={
                      formData.collectedDateTime
                        ? `Storage Days: ${
                            getYardCalendarDaysInclusive(
                              formData.placementDateTime ||
                                formData.arrivalDateTime,
                              formData.collectedDateTime,
                            ) ?? 0
                          }`
                        : false
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <CollectedAtIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            )}
            {formData.carrierName !== "TRANSFER" &&
              isEmpty(formData.transfer) && (
                <Grid container direction="row" spacing={2}>
                  {formData?.account?.trackOutboundSeals &&
                    formData.carrierName !== "TRANSFER" &&
                    !isXSmall && (
                      <Grid item xs={12} md={4}>
                        <Box mt={1}>
                          <Button
                            label={getSealNumberButtonLabel(formData)}
                            variant="outlined"
                            size="large"
                            fullWidth
                            onClick={handleOpen}
                          >
                            <SealIcon />
                          </Button>
                        </Box>
                      </Grid>
                    )}
                </Grid>
              )}
            {openSeals && (
              <SealNumbersDialog
                open={openSeals}
                onClose={handleClose}
                formData={formData}
              />
            )}
          </Grid>
        )}
      </FormDataConsumer>
    </MuiPickersUtilsProvider>
  );
};

const EditToolbar = ({
  record,
  operatingAccount,
  backPath,
  selectedTimeslot,
  setAllInventories,
  loading,
  setIsLoaded,
  ...props
}) => {
  const classes = useStyles();
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  return (
    <Toolbar style={{ justifyContent: "space-between" }}>
      <Backdrop className={classes.backdrop} open={isSaving || isDeleting}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {record?.status === OutboundStatus.ADVICE_PENDING ? (
        <AdviceApproveRejectButton
          {...props}
          record={record}
          backPath={backPath}
          loading={loading}
          isSaving={isSaving}
          setIsSaving={setIsSaving}
          isDeleting={isDeleting}
        />
      ) : (
        <DialogSaveButton
          {...props}
          record={record}
          operatingAccount={operatingAccount}
          backPath={backPath}
          selectedTimeslot={selectedTimeslot}
          isSaving={isSaving}
          setIsSaving={setIsSaving}
          isDeleting={isDeleting}
          loading={loading}
          setIsLoaded={setIsLoaded}
          setAllInventories={setAllInventories}
        />
      )}
      <DeepDeleteButton
        {...props}
        record={record}
        backPath={backPath}
        isSaving={isSaving}
        isDeleting={isDeleting}
        setIsDeleting={setIsDeleting}
      />
    </Toolbar>
  );
};

const validateOutboundEdit = (values) => {
  let errors = {};

  if (values.shipmentLineItems && values.shipmentLineItems.items) {
    values.shipmentLineItems.items.forEach((row) => {
      const error = validatePickListRow(row);
      if (error.helperText) errors = error;
    });
  }

  return errors;
};

export const OutboundEdit = (props) => {
  const backPath = getBackPath(props);
  const { record, loading } = useEditController(props);
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const history = useHistory();
  const notify = useNotify();
  const [bolFile, setBolFile] = useState();
  const [bolNumber, setBolNumber] = useState();
  const [photos, setPhotos] = useState(record?.photos?.items || []);
  const [shipmentLineItems, setShipmentLineItems] = useState(
    record?.shipmentLineItems || [],
  );
  const [allInventories, setAllInventories] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isContainerPickUp, setIsContainerPickUp] = useState(false);
  const [selectedTimeslot, setSelectedTimeslot] = useState(record?.timeslot);
  const [operatingAccount, setOperatingAccount] = useOperatingAccount(record);

  useEffect(() => {
    if (record?.timeslot) setSelectedTimeslot(record.timeslot);
  }, [record?.timeslot]);

  useEffect(() => {
    if (record?.shipmentLineItems) {
      setShipmentLineItems(record.shipmentLineItems);
    }
  }, [record?.shipmentLineItems]);

  useEffect(() => {
    if (record?.containerPickup) setIsContainerPickUp(record.containerPickup);
  }, [record?.containerPickup]);

  useEffect(() => {
    if (record?.photos?.items?.length > 0) setPhotos(record.photos.items);
  }, [record?.photos?.items]);

  if (!record) return <Loading />;
  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Outbound" />}
      mutationMode="pessimistic"
      actions={
        <OutboundEditActions
          {...props}
          loading={loading}
          backPath={backPath}
          setBolFile={setBolFile}
          setBolNumber={setBolNumber}
        />
      }
      aside={
        <OutboundAside
          {...props}
          backPath={backPath}
          history={history}
          photos={photos}
        />
      }
    >
      <TabbedForm
        variant="outlined"
        submitOnEnter={false}
        toolbar={
          <EditToolbar
            {...props}
            record={record}
            operatingAccount={operatingAccount}
            backPath={backPath}
            selectedTimeslot={selectedTimeslot}
            setAllInventories={setAllInventories}
            loading={loading}
            setIsLoaded={setIsLoaded}
          />
        }
        validate={(values) => validateOutboundEdit(values)}
      >
        <FormTab path="" label="Outbound Setup">
          <ShipmentSetupTab
            {...props}
            record={record}
            operatingAccount={operatingAccount}
            setOperatingAccount={setOperatingAccount}
            backPath={backPath}
            bolFile={bolFile}
            bolNumber={bolNumber}
            photos={photos}
            setPhotos={setPhotos}
            setIsContainerPickUp={setIsContainerPickUp}
            setShipmentLineItems={setShipmentLineItems}
            history={history}
            notify={notify}
          />
        </FormTab>
        <FormTab path="pickList" label="Tally Sheet">
          <PickListTab
            {...props}
            operatingAccount={operatingAccount}
            isContainerPickUp={isContainerPickUp}
            backPath={backPath}
            shipmentLineItems={shipmentLineItems}
            setShipmentLineItems={setShipmentLineItems}
            allInventories={allInventories}
            setAllInventories={setAllInventories}
            isLoaded={isLoaded}
            setIsLoaded={setIsLoaded}
          />
        </FormTab>
        {record.status === OutboundStatus.ADVICE_PENDING ? (
          <FormTab path="dispatch" label="Dispatch">
            <AdviceDispatchTab {...props} />
          </FormTab>
        ) : (
          <FormTab path="dispatch" label="Dispatch">
            <DispatchTab
              {...props}
              selectedTimeslot={selectedTimeslot}
              setSelectedTimeslot={setSelectedTimeslot}
            />
          </FormTab>
        )}
        <FormTab path="notes" label="Notes">
          <NotesTab />
        </FormTab>
        {lgUp && (
          <FormTab path="historyLog" label="History Log">
            <HistoryTab />
          </FormTab>
        )}
      </TabbedForm>
    </Edit>
  );
};
